import ReactDOM from 'react-dom/client'
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import configureStore from './store/configureStore';
import { Provider } from 'react-redux';
import { ConfigProvider, theme, App as AntdApp } from 'antd';
import { BrowserRouter } from 'react-router-dom';
import 'dayjs/locale/zh-cn';
import locale from 'antd/locale/zh_CN';
import dayjs from 'dayjs';
import { AntdMessageHolder } from './utilsTsx/components/system/antdMessage';

dayjs.locale('zh-cn')
const store = configureStore();
const container = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(container!);

root.render(
  <BrowserRouter>
    <ConfigProvider
      locale={locale}
      theme={{
        algorithm: theme.darkAlgorithm,
        // 👇 新增下面这块代码 👇
        components: {
          Form: {
            itemMarginBottom: 12,       // 缩小表单每一项的底部间距 (默认是 24)
            verticalLabelPadding: '0 0 4px', // 如果是垂直布局，缩小 label 和输入框的间距 (默认是 '0 0 8px')
          },
        },
        // 👆 新增结束 👆
      }}
    >
      <AntdApp>
        <AntdMessageHolder />
        <Provider store={store}>
          <App />
        </Provider>
      </AntdApp>
    </ConfigProvider>
  </BrowserRouter>
);

serviceWorker.unregister();